module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-7-1368d43b23f49ae64bdce2e2c26c3a58.svg";